import styled, { css } from "styled-components"
import { CursorCircleWhite } from "shared/Styles/Cursors"

const image = css`
  position: absolute;
  z-index: 100;
  object-fit: contain;
  ${CursorCircleWhite}
`
const gatsbyImageWrapper = css`
  width: 100%;
  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }
`
const displayNone = css`
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tabletSmall}) {
    display: none;
  }
`
export const ParallaxPhotosWrapper = styled.div`
  position: absolute;
  width: 100%;
  bottom: -340px;
`
export const PhotosContainer = styled.div`
  /* z-index: 3;
  @media screen and (max-width: ${({ theme }) =>
    theme.breakpoints.tabletSmall}) {
    transform: translateY(-200px);
  } */
  // need work
`
export const Photo__0 = styled.div`
  ${image}
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  max-width: 30vw;
  ${gatsbyImageWrapper}
  @media screen and (max-width: ${({ theme }) =>
    theme.breakpoints.tabletSmall}) {
    max-width: 80vw;
  }
`
export const Photo__1 = styled.div`
  ${image}
  left: 10%;
  bottom: 0;
  max-width: 30vw;
  ${displayNone}
  ${gatsbyImageWrapper}
`
export const Photo__2 = styled.div`
  ${image}
  left: 64%;
  bottom: 0;
  max-width: 30vw;
  ${displayNone}
  ${gatsbyImageWrapper}
`
